"use client";

import { usePathname } from "next/navigation";
import { ThemeProvider as NextThemesProvider } from "next-themes";

export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  const pathname = usePathname();
  const isAuthenticationRoute = ['/sign-in', '/sign-up', '/forgot-password'].some(route =>
    pathname.startsWith(route),
  );

  return <NextThemesProvider {...props} forcedTheme={isAuthenticationRoute ? 'dark' : props.forcedTheme}>{children}</NextThemesProvider>;
}
